import React, { useEffect, useRef, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    FieldWrappers,
} from "../Styles/InputStyles";
import { Select, MenuItem } from "@mui/material";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import { MdClose, MdEdit } from "react-icons/md";
import CategoryCard from "../CategoryCard";
import SinglePropSelectModal from "../SinglePropSelectModal";
import { assetAssignStatus, assetAssignTo } from "../../Config";
import SelectOptionModal from "../SelectOptionModal";

const EditAssignmentDetails = ({
    setIsEditAssignmentDetails,
    property,
    editAssignPropertyMutate,
    editAssignPropertyLoading,
    selectedData,
    selectedPropertyAssets,
    selectedProperty
}) => {
    const formikRef = useRef(null);
    const [height, setHeight] = useState(window.innerHeight);
    const [showPropertyModal, setShowPropertyModal] = useState(false)
    const [selectedProp, setSelectedProperty] = useState(selectedProperty);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isAssignStatusModalOpen, setIsAssignStatusModalOpen] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const initialValues = {
        assignedProperty: selectedProperty?.propId,
        assignTo: selectedProperty?.assignedTo,
        currentStatus: selectedProperty?.status,
        count: selectedProperty?.unitCount,
        assetId: selectedProperty?.assetId,
        id: selectedProperty?.id,
    };
    const assignToOptions = assetAssignTo.map(role => ({
        label: role.label,
        value: role.value,
    }));
    const assignStatusOptions = assetAssignStatus.map(role => ({
        label: role.label,
        value: role.value,
    }));
    const validationSchema = Yup.object({
        assignedProperty: Yup.string().required("Select Property"),
        assignTo: Yup.string().required("Select Assign To"),
        currentStatus: Yup.string().required("Select Current Status"),
        count: Yup.number()
            .required("Count is required")
            .min(0, "Units should not be less than 0")
            .max(10000, "Units should be less than 10000")
        // .test(
        //     'is-less-than-free',
        //     `Count should not be more than ${selectedData?.free}`,
        //     function (value) {
        //         return value <= selectedData?.free;
        //     }
        // ),
    });

    const handleSubmit = (values) => {
        editAssignPropertyMutate({
            assetId: selectedProperty?.assetId,
            propId: values.assignedProperty,
            count: Number(values.count),
            status: Number(values.currentStatus),
            assignedTo: Number(values.assignTo),
            id: selectedProperty?.id,
        });
    };

    const handleSelectedProperty = (selectedOption) => {
        setSelectedProperty(selectedOption);
        if (formikRef.current) {
            formikRef.current.setFieldValue("assignedProperty", selectedOption.id)
        }
    }

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>
                <Title>{"Edit Assign Property"}</Title>
                <CloseButton onClick={() => setIsEditAssignmentDetails(false)}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={validationSchema}
                    enableReinitialize
                >
                    {({ values, setFieldValue, errors, touched }) => {
                        const getAssignLabel = () => {
                            const selectedAssignTo = assetAssignTo.find(role => role.value === values?.assignTo);
                            return selectedAssignTo ? selectedAssignTo.label : "Select Assign To";
                        };
                        const getAssignStatusLabel = () => {
                            const selectedAssignStatus = assetAssignStatus.find(role => role.value === values?.currentStatus);
                            return selectedAssignStatus ? selectedAssignStatus.label : "Select Assign Status";
                        };
                        const handleAssignStatusSelect = (selectedValue) => {
                            setFieldValue("currentStatus", selectedValue);
                        };
                        const handleAssignToSelect = (selectedValue) => {
                            setFieldValue("assignTo", selectedValue);
                        };
                        return (
                            <Form>
                                <ScrollableContent>
                                    <Wrapper>
                                        <InputGroup>
                                            <Label>Select Property *</Label>
                                            <CategoryCard
                                                title="Property"
                                                selectedCategory={selectedProp}
                                                onClick={() => setShowPropertyModal(true)}
                                            />
                                        </InputGroup>
                                        {/* <InputGroup>
                                        <Label>Select Property *</Label>
                                        <Select
                                            value={values.assignedProperty}
                                            onChange={(e) => {
                                                setFieldValue("assignedProperty", e.target.value);
                                            }}
                                            displayEmpty
                                            fullWidth
                                            className="px-2"
                                            style={{ height: "46px" }}
                                        >
                                            <MenuItem value="" disabled>
                                                Select Property
                                            </MenuItem>
                                            {property?.map((prop) => (
                                                <MenuItem key={prop.id} value={prop.id}>
                                                    {prop.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors.assignedProperty && touched.assignedProperty && (
                                            <ErrorText>{errors.assignedProperty}</ErrorText>
                                        )}
                                    </InputGroup> */}
                                        <InputGroup>
                                            <Label htmlFor="count">Assign Units *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="text"
                                                    id="count"
                                                    name="count"
                                                    inputMode="numeric"
                                                    value={values.count}
                                                    autoComplete="off"
                                                    onKeyPress={(e) => {
                                                        if (!/[0-9]/.test(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    maxLength={10}
                                                />
                                            </FieldWrappers>
                                            {touched.count && errors.count && (
                                                <ErrorText>{errors.count}</ErrorText>
                                            )}
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="assignTo">Assign To *</Label>

                                            {/* <Select
                                            name="assignTo"
                                            id="assignTo"
                                            value={values.assignTo}
                                            onChange={(e) =>
                                                setFieldValue("assignTo", e.target.value)
                                            }
                                            className="w-full pl-2"
                                            style={{ height: "46px" }}
                                        >
                                            <MenuItem value="1">Tenant</MenuItem>
                                            <MenuItem value="2">Maintenance Staff</MenuItem>
                                            <MenuItem value="3">Unassigned</MenuItem>
                                        </Select> */}
                                            <FieldWrappers onClick={() => setIsAssignModalOpen(true)}>
                                                <Field
                                                    type="text"
                                                    name="assignTo"
                                                    id="assignTo"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getAssignLabel()}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                />
                                                <IconWrapper >
                                                    <MdEdit className="w-3 h-3" />
                                                </IconWrapper>
                                                {/* <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" /> */}

                                            </FieldWrappers>
                                            {errors.assignTo && touched.assignTo && (
                                                <ErrorText>{errors.assignTo}</ErrorText>
                                            )}
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="currentStatus">Current Status *</Label>
                                            <FieldWrappers onClick={() => setIsAssignStatusModalOpen(true)}>
                                                <Field
                                                    type="text"
                                                    name="currentStatus"
                                                    id="currentStatus"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getAssignStatusLabel()}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                />
                                                <IconWrapper >
                                                    <MdEdit className="w-3 h-3" />
                                                </IconWrapper>
                                                {/* <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" /> */}
                                            </FieldWrappers>
                                            {/* <Select
                                                name="currentStatus"
                                                id="currentStatus"
                                                value={values.currentStatus}
                                                onChange={(e) =>
                                                    setFieldValue("currentStatus", e.target.value)
                                                }
                                                className="w-full pl-2"
                                                style={{ height: "46px" }}
                                            >
                                                <MenuItem value="1">Active</MenuItem>
                                                <MenuItem value="2">In Maintenance</MenuItem>
                                                <MenuItem value="3">Disposed</MenuItem>
                                                <MenuItem value="4">In Use</MenuItem>
                                            </Select> */}

                                            {errors.currentStatus && touched.currentStatus && (
                                                <ErrorText>{errors.currentStatus}</ErrorText>
                                            )}
                                        </InputGroup>
                                    </Wrapper>
                                </ScrollableContent>
                                <ActionSection>
                                    <SideCancelBtn
                                        type="button"
                                        onClick={() => setIsEditAssignmentDetails(false)}
                                    >
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={editAssignPropertyLoading}>
                                        {editAssignPropertyLoading ? "Submitting..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>
                                <SinglePropSelectModal
                                    isOpen={showPropertyModal}
                                    onClose={() => setShowPropertyModal(false)}
                                    onSelect={handleSelectedProperty}
                                    options={property}
                                    selectedProperty={selectedProp}
                                />
                                <SelectOptionModal
                                    isOpen={isAssignModalOpen}
                                    onClose={() => setIsAssignModalOpen(false)}
                                    title="Select Assign To"
                                    options={assignToOptions}
                                    selectedValue={values.assignTo}
                                    onSelect={handleAssignToSelect}
                                    searchPlaceholder="Search assign to..."
                                />
                                <SelectOptionModal
                                    isOpen={isAssignStatusModalOpen}
                                    onClose={() => setIsAssignStatusModalOpen(false)}
                                    title="Select Assign Status"
                                    options={assignStatusOptions}
                                    selectedValue={values.currentStatus}
                                    onSelect={handleAssignStatusSelect}
                                    searchPlaceholder="Search assign status..."
                                />
                            </Form>
                        )
                    }}
                </Formik>
            </Content>
        </Container>
    );
};


const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-600 font-normal mb-1.5`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-6 h-full flex flex-col justify-between relative`;
const IconWrapper = tw.div`mr-2 flex-shrink-0 p-2 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600`;
export default EditAssignmentDetails;
